<template>
    <div class="abstract-check-in-info" :class="{'add-coupon-open' : addCouponOpen}">
        <h5>Resumen de tu compra</h5>
        <div class="price" :class="{'discount-applied': couponApplied}">
            <div class="d-flex align-items-start h-full">
              <span>Total a pagar</span>
            </div>
            <div class="box-discount">
                <span v-if="couponApplied && getPercentaje() !== 0" class="old-price-value">{{ subTotal | moneyFormatter }} **</span>
                <span class="price-value">
                  {{ total | moneyFormatter }} **
                </span>
                <span v-if="couponApplied && getPercentaje() !== 0" class="discount">
                    <img src="/images/featured/tick-circle-bold.svg" class="mr-1" />
                    {{ getPercentaje() }}% DCTO.
                </span>
            </div>
        </div>
        <!--div class="d-flex align-items-center justify-content-between mb-3" v-if="!couponApplied">
          <div>
            <img
              src="/images/featured/ticket-discount.svg"
              alt="ticket-discount"
            />
            <a href="#" class="btn-add-coupon pointer" @click.prevent="addCouponOpen = true" >
                Agregar cupón de descuento
            </a>
          </div>
          <img v-on:click="addCoupon" class="close-add-coupon pointer" src="/images/featured/close-circle-primary.svg" alt="" v-if="addCouponOpen" >
        </div-->
        <div class="d-flex align-items-center justify-content-between mb-3" v-if="couponApplied && validCoupon" >
          <div>
            <img
              src="/images/featured/ticket-discount.svg"
              alt="ticket-discount"
            />
            <a href="#" style="pointer-events: none" class="btn-add-coupon pointer" @click.prevent="addCouponOpen = true" >
              Cupón aplicado: {{ this.coupon }}
            </a>
          </div>
          <img v-on:click="removeCoupon" class="close-add-coupon pointer" src="/images/featured/close-circle-primary.svg" alt="">
        </div>
        <form id="addCoupon" @submit.prevent="ifFormValid( $event, applyCoupon )" class="mb-3" >
            <div class="add-coupon-container" v-if="addCouponOpen">
                <div class="pdv-form-group">
                    <div class="content-coupon">
                        <div class="form-group mb-0 w-70">
                            <label for="inputCoupon" class="label-input">Código de tu cupón</label>
                            <input type="text" id="inputCoupon w-full" v-model="coupon" class="input-coupon" 
                                placeholder="Ej: AE2 6DG" name="cupon"
                                maxlength="16"
                                @input="coupon = $event.target.value.toUpperCase()"
                                :disabled="couponApplied && validCoupon"
                            >
                        </div>
                        <div class="form-group mb-0 w-30">
                            <label for="inputCoupon"><span class=" text-transparent">.</span></label>
                            <button type="submit" class="boton-new-primario boton-new-mediano w-full">APLICAR</button>
                        </div>
                    </div>
                    <label class="error-label" v-if="!validCoupon" >El código del cupón ingresado no es válido.</label>
                </div>
            </div>
        </form>
        <div class="t-and-cond">
            <input  v-model="checkboxChecked" class="checkb" type="checkbox" id="terms" name="terminos  "/>
            <span>Por este acto el estudiante/a y/o su apoderado/a, declaran que leyeron el Contrato de Prestación de Servicios
                 Educacionales que 
                se suscribe, así como la totalidad de sus anexos. Al mismo tiempo, declaran su completa conformidad con sus </span>
            <a :href="ruleBook"
                target="_blank"
                > <strong class="terms">TÉRMINOS Y CONDICIONES</strong> </a>
        </div>
        <button @click="emitButtonClickedEvent" type="button" class="boton-new-primario boton-new-mediano w-full mb-3" data-dismiss="modal" :disabled="!isButtonEnabled"> Confirmar compra </button>

        <!--label class="error-label" v-if="!validCoupon" >El código del cupón ingresado no es válido.</label-->
        <!-- <button @click="emitButtonClickedEvent" type="button" class="boton-new-primario boton-new-mediano w-full mb-3" data-dismiss="modal" :class="{ 'disabled': !checkboxChecked }">Confirmar compra</button> -->
    </div>
</template>

<script>
    import formValidation from "@/mixins/formValidation";
    global.jQuery = require("jquery");
    var $ = global.jQuery;
    window.$ = $;

    export default {
        data() {
            return {
                coupon: null,
                addCouponOpen: false,
                couponError: false,
                couponApplied: false,
                ruleBook: "https://ventaonline.preupdv.cl/api/static/PDV_CONTRATO_REGLAMENTO.pdf",
                isButtonEnabled: false,
                checkboxChecked: false,
            }
        },

        props: {
            total: Number,
            subTotal: Number,
            precioSubTotal: Number,
            valorDescuentoCupon: Number,
            valorDescuento: Number,
            validCoupon: {
                type: Boolean,
                default: true
            }
        },

        mixins:[
            formValidation
        ],

        methods:{
            addCoupon(){
                this.addCouponOpen = !this.addCouponOpen;
                this.$emit('addCouponClicked');
            },
            applyCoupon(){
                //this.addCouponOpen = false;
                this.couponApplied = true;
                this.$emit('apllyCouponClicked',this.coupon)
            },
            emitButtonClickedEvent(){
            if (this.checkboxChecked) {
             this.$emit('buttonClicked');
             } else {
            alert('Debe aceptar los términos y condiciones para continuar.');
            }
            },
            getPercentajeOld(){
                if(this.subTotal === 0){
                    return 0
                } else {
                    return Math.round(((this.subTotal-this.total)* 100) / this.subTotal)
                }
            },
            getPercentaje(){
                if(this.subTotal === 0){
                    return 0
                } else {
                    return Math.round( (this.valorDescuentoCupon / (this.precioSubTotal- this.valorDescuento)) * 100)
                }
            },
            removeCoupon(){
                this.couponApplied = false
                this.addCouponOpen = false
                this.coupon= null
                this.$emit('removeCoupon');
            }
        },

        mounted() {
            this.validateForm($('#addCoupon'), {
                    cupon:{
                        required: true
                    }
                },
                {
                    cupon:{
                        required: 'Debe ingresar el código del cupón.'
                    }
                }
            );
        },
        watch: {
        checkboxChecked(newVal) {
        this.isButtonEnabled = newVal;
    },
},


    }
</script>

<style scoped lang="scss">

.t-and-cond{
    padding: 10px;
}
.checkb{
    width:15px;
    height: 15px;
    margin-right: 10px;   
}
.terms{
font-family: 'Poppins-Bold', sans-serif;
color: #592466;
text-decoration: underline;
font-weight: bold;
}
    .abstract-check-in-info {
        padding: 24px;
        background: $neutral05;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.18);
        @media (max-width: 768px) {
          width: 100%;
        }
        @media (min-width: 769px) {
          width: 500px;
        }
     
        h5 {
            color: $neutral70;
            font-family: 'Poppins-Regular', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
        }

        .price {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
            span {
                color: $neutralBlack;
                font-family: 'Poppins-Medium', sans-serif;
                font-size: 18px;
                font-style: normal;
                font-weight: 500;
                line-height: 26px; 
            }
            .price-value{
                position: relative;
                color: $neutral70;
                text-align: right;
                font-family: 'Poppins-Bold', sans-serif;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 26px; 
            }
            .old-price-value{
                position: relative;
                color: $neutral70;
                text-align: right;
                font-family: 'Poppins-Bold', sans-serif;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 26px; 
                text-decoration: line-through;
                @include alternative-regular;
            }
            .discount{
                border-radius: 8px;
                border: 1px solid #0A5C33;
                background: #F0FFF7;
                padding: 0 7px;
                color: #0F8047;
                text-align: center;
                font-family: 'Poppins-Medium', sans-serif;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 22px;
            }
            &.discount-applied{
                margin-bottom: 30px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start !important;
            }
        }


        .add-coupon-container {
            /*background: #FFF3D7;*/
            padding: 0px;
            position: relative;
            width: 100%;
            .close-add-coupon {
                font-size: 30px;
                cursor: pointer;
            }

            .form-group {
                label {
                    width: 100%;
                }

                input[type="text"] {
                    max-width: 100%;
                    background: #fff;
                    &::placeholder{
                        font-style: italic;
                    }
                }
            }
        }
        // @include media-breakpoint-down(sm){
            
        //     width: 100%;
        //     box-shadow: 0 -2px 6px 0 rgba(0,0,0,0.1);
        //     bottom: 0;
        //     left: 0;
        //     z-index: 100;
        //     top: unset;
        //     right: unset;
            
        // }
    }
    .abstract-check-in-info .error{
        input{
            border: 2px solid $red-2 !important;
            background: #FFE4E6 !important;
        }
    }

    .error-label{
        color: #DC3545;
        font-size: 12px;
        line-height: 14px;
        display: inline-block;
        font-family: "ubunturegular", Arial, sans-serif;
        margin-bottom: 10px;
    }

    .btn-black {
        background: #000 !important;
        color: #FBCE20 !important;
        -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.18);
        box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.18);
        -webkit-transition: all 0.3s ease;
        transition: all 0.3s ease;
        position: relative;
        border: 1px solid #FBCE20;
        -webkit-appearance: unset;
        font-family: "ubuntubold", Arial, sans-serif;
        font-size: 16px;
        line-height: 18px;
        padding: 16px 19px;
        display:  flex;
        justify-content: center;
        align-items: center;
        &:hover{
            background: #FBCE20 !important;
            color: #000 !important;
        }
    }

    .box-discount{
        display: flex;
        flex-direction: column;
        width: auto;
        align-items: end;
    }

    .btn-add-coupon{
        color: #592466;
        font-family: 'Poppins-Medium', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
    }

.label-input {
  color: $neutralBlack;
  font-family: 'Poppins-Medium', sans-serif !important;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 500;
  line-height: 22px !important; 
}
.input-coupon{
  border-radius: 100px !important;
  border: 2px solid $neutral30 !important;
  background: #FFF !important;
  padding: 12px 24px !important;
}

.boton-new-primario.disabled {
    background-color: #ccc; /* Color de fondo gris */
    cursor: not-allowed; /* Cursor no permitido */
}


</style>